module.exports = __webpack_public_path__ + "img/1.a29a6908.png";